import { PayPalButtons } from "@paypal/react-paypal-js";
import { CreateOrderActions, CreateOrderData, OnApproveActions, OnApproveData, OnCancelledActions } from "@paypal/paypal-js";

export type PaypalEvents = {
    onCreateOrder: ((data: CreateOrderData, actions: CreateOrderActions) => Promise<string>) | undefined,
    onApprove: ((data: OnApproveData, actions: OnApproveActions) => Promise<void>) | undefined,
    onCancel: ((data: Record<string, unknown>, actions: OnCancelledActions) => void) | undefined,
    onError: ((err: Record<string, unknown>) => void | undefined)
}

export const OnsitePaypalButton = (props: PaypalEvents) => {
    return (
        <>
            <PayPalButtons
                createOrder={props.onCreateOrder}
                onApprove={props.onApprove}
                onCancel={props.onCancel}
                onError={props.onError}
                style={{ layout: "vertical", height: 55 }}
            />
        </>
    );
}